import React from "react"
import moment from "moment"
import { Table } from "react-bootstrap"
import { fillingZeroUtility, formatCurrency, getFrequencyText } from "../../../lib/utils"
import AlertModal from "../../fragments/AlertModal"
import CaptionTable from "../../fragments/CaptionTable"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import WalletAddress from "../../fragments/WalletAddress"
import InvestorLink from "../../fragments/InvestorLink"

export default class RenderDeposits extends React.Component {

  state = {
    deposit: null,
    shouldDisplay: false,
    shouldDelete: false,
    showFullWallet: false, 
    running: false,
    success: false,
    error: null,
  }

  showDeleteForm = () => this.setState({ 
    shouldDisplay: false,
    shouldDelete: true,
  })

  showDepositItem = deposit => this.setState({
    deposit,
    shouldDisplay: true,
    shouldDelete: false,
    showFullWallet: false,
    running: false,
    success: false,
    error: null,
  })

  closeDisplayForm = () => this.setState({ shouldDisplay: false })

  closeDeleteForm = () => this.setState({ shouldDelete: false })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { bucketId, setFinancierBucket } = this.props,
    { deposit: { id: depositId }} = this.state

    blockingFetchService(
      accessToken => apiServerApi.removeMoneyFinancierFucket(accessToken, bucketId, depositId),
      resp => {

        this.setState({ success: true })
        setTimeout(() => {
          this.closeDeleteForm()
          setFinancierBucket(bucketId, resp)
        }, 800)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderDeletionContent = deposit => {

    const { running, success, error } = this.state,
    { investor: { name }, amount } = deposit,
    text = `${ amount } of ${ name }`

    return (
      <div>
        <h3>Are you sure you want to remove the deposit: { text }?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderTr = (title, value, className) => <tr className={ className }>
    <td className="strong">{ title }</td>
    <td>{ value }</td>
  </tr>

  renderDepositDetails = deposit => {

    const { investor: { id: investorId, name, bankName, walletAddress }, amount, period,
      periodType, createdOn } = deposit,
    { showFullWallet } = this.state

    return (
      <Table responsive striped bordered condensed hover>
        <tbody>

          <tr>
            <td width="30%" className="strong">Investor name</td>
            <td><InvestorLink id={ investorId } name={ name } /></td>
          </tr>

          { this.renderTr('Amount', formatCurrency(amount)) }

          { this.renderTr(
            'Period',
            `${ fillingZeroUtility(period) } ${ getFrequencyText(periodType) }`
          )}

          { this.renderTr('Bank name', bankName) }

          { this.renderTr(
            'Wallet address',
            <WalletAddress address={ walletAddress } shouldShow={ showFullWallet }
              onClick={() => this.setState({ showFullWallet: !showFullWallet })}
            />
          )}

          { this.renderTr(
            'Created on',
            createdOn ? moment(createdOn).format('lll') : '',
            'gray'
          )}
        </tbody>
      </Table>
    )
  }

  renderThs = () => <tr>
    <th className="gray font-size-13">Date</th>
    <th>Name</th>
    <th>Amount</th>
    <th>Period</th>
  </tr>

  getData = deposits => deposits.map((item, index) => {

    const { investor: { name }, amount, period, periodType, createdOn } = item

    return <tr key={ index } className="cursor-pointer" title="Show details"
      onClick={_ => this.showDepositItem(item)}>

      <td className="gray">
        <small>{ createdOn ? moment(createdOn).format('ll') : '' }</small>
      </td>

      <td>{ name }</td>

      <td>{ formatCurrency(amount) }</td>

      <td>{ fillingZeroUtility(period) } { getFrequencyText(periodType) }</td>
    </tr>
  })

  render() {

    const { deposits, closed } = this.props
    if (!deposits) return null

    const { deposit, shouldDisplay, shouldDelete, running } = this.state,
    title = deposit ? <span>Deposit &nbsp; #{ deposit.id }</span> : ''

    return (
      <div>
        <Table striped condensed hover responsive>

          <CaptionTable text='Investors' />

          <tbody>
            { this.renderThs() }
            { this.getData(deposits) }
          </tbody>
        </Table>

        { !!deposit &&
        <AlertModal
          show={ shouldDisplay }
          title={ title }
          body={ this.renderDepositDetails(deposit) }
          close={ this.closeDisplayForm }
          bsStyle="danger"
          confirm={ this.showDeleteForm }
          proceedText="Remove"
          disabled={ running || closed }
        />}

        { !!deposit &&
        <AlertModal
          show={ shouldDelete }
          title="Confirm deletion"
          body={ this.renderDeletionContent(deposit) }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Proceed"
          disabled={ running }
        />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/RenderDeposits.js